/**
 * Thin GA4 event helper. No-ops when gtag hasn't loaded (it's lazyOnload) or
 * during SSR. Event names here are the ones to mark as "Key events"
 * (conversions) in GA4 Admin → Events:
 *   - beta_form_success   (fired by beta-signup-form.tsx on a completed signup)
 *   - request_access_click (any "Request access" CTA → /beta)
 *   - pricing_cta_click    (a CTA clicked from the /pricing page)
 *   - contact_sales_click  (a "Talk to us" / contact CTA)
 */
export function trackEvent(event: string, params: Record<string, unknown> = {}) {
  if (typeof window === "undefined") return;
  const w = window as unknown as {
    dataLayer?: unknown[];
    gtag?: (...a: unknown[]) => void;
  };
  // Push to the GTM dataLayer so each conversion is available to future
  // Google Ads / Meta / LinkedIn conversion + remarketing tags — added in the
  // GTM UI with no code deploy. IMPORTANT: don't also add a GA4 *event* tag on
  // these in GTM — GA4 already receives them via the gtag call below, so a GTM
  // GA4 event tag would double-count. In GTM, trigger only Ads/Meta conversion
  // tags off these events.
  w.dataLayer = w.dataLayer || [];
  w.dataLayer.push({ event, ...params });
  // Send straight to GA4 (GTM's Google tag defines window.gtag once it loads).
  w.gtag?.("event", event, params);
}
